<template>
    <div>
        <h5 class="heading-1">
            <span>BENEFICIÁRIO</span>
        </h5>
        <app-k-v titulo="CNPJ" :md="4" :lg="3" :xl="2" :dado="$maskCpfCnpj(beneficiario.cnpj)"></app-k-v>
        <app-k-v titulo="Nome" :md="4" :lg="3" :xl="2" :dado="beneficiario.nome"></app-k-v>
    </div>
</template>

<script>
export default {
	props: {
		beneficiario: {
			type: Object,
			default: () => {}
		}
	}
}
</script>
